import { render, staticRenderFns } from "./choiceBox.vue?vue&type=template&id=2e4ad10a&scoped=true&"
import script from "./choiceBox.vue?vue&type=script&lang=js&"
export * from "./choiceBox.vue?vue&type=script&lang=js&"
import style0 from "./choiceBox.vue?vue&type=style&index=0&id=2e4ad10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4ad10a",
  null
  
)

export default component.exports